const modulesFiles = require.context('.', true, /\.vue$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default Vue => {
  Object.keys(modules).forEach(key => {
    const com = modules[key]
    Vue.component(com.name, com)
  })
}
